// Ограничения на загружаемый медиа-контент архива
export const MAX_VIDEO_SECONDS = 15 * 60; // 15 минут
export const MAX_VIDEO_BYTES = 1024 * 1024 * 1024; // 1 ГБ — здравый предел по размеру

export function isVideoFile(file) {
    return !!file && typeof file.type === "string" && file.type.startsWith("video/");
}

// Читает длительность видео из метаданных, не загружая весь файл
export function getVideoDuration(file) {
    return new Promise((resolve, reject) => {
        try {
            const url = URL.createObjectURL(file);
            const video = document.createElement("video");
            video.preload = "metadata";
            video.muted = true;

            const cleanup = () => URL.revokeObjectURL(url);

            video.onloadedmetadata = () => {
                const duration = video.duration;
                cleanup();
                resolve(duration);
            };
            video.onerror = () => {
                cleanup();
                reject(new Error("Не удалось прочитать метаданные видео"));
            };

            video.src = url;
        } catch (e) {
            reject(e);
        }
    });
}

// Форматирует секунды как M:SS
export function formatSeconds(totalSeconds) {
    const s = Math.floor(totalSeconds % 60);
    const m = Math.floor(totalSeconds / 60);
    return `${m}:${String(s).padStart(2, "0")}`;
}
